import styled from 'styled-components';
import {
  FrameHeaderHeight,
  OldFrameSidebarWidth,
  MobileFrameHeaderHeight,
} from 'styles/constants';

type SpacingProps = {
  active: boolean;
  withoutLeftSpacing?: boolean;
};

export const SpacingToAvoidFrameDesktop = styled.div<SpacingProps>(
  ({ active, withoutLeftSpacing = false, hidePaddingTop = false }) => {
    if (!active) return {};
    return {
      paddingTop: `${hidePaddingTop ? 0 : FrameHeaderHeight}px`,
      width: '100%',
      paddingLeft: withoutLeftSpacing ? '0px' : `${OldFrameSidebarWidth}px`,
    };
  },
);

export const SpacingToAvoidFrameMobile = styled.div<SpacingProps>(
  ({ active }) => {
    if (!active) return {};
    return {
      paddingTop: `${MobileFrameHeaderHeight}px`,
    };
  },
);
